<template>
  <LayoutLegal>
    <h2>DMCA Notice</h2>
    <h3 id="1">Reporting Claims of Copyright Infringement</h3>
    <p>
      We take claims of copyright infringement seriously. We will respond to
      notices of alleged copyright infringement that comply with applicable law.
      If you believe any materials accessible on or from the Platform infringe
      your copyright, you may request removal of those materials (or access to
      them) from the Platform by submitting written notification to our
      Copyright Agent (designated below). In accordance with the Online
      Copyright Infringement Liability Limitation Act of the Digital Millennium
      Copyright Act (17 U.S.C. § 512
      <a href="http://www.copyright.gov/title17/92chap5.html">DMCA</a>
      , the written notice (the &quot;DMCA Notice&quot;) must include
      substantially the following:
    </p>
    <ul class="list-disc ml-8 leading-loose">
      <li>Your physical or electronic signature.</li>
      <li>
        Identification of the copyright work you believe to have been infringed
        or, if the claim involves multiple works on the Platform, a
        representative list of the works.
      </li>
      <li>
        Identification of the material you believe to be infringing in a
        sufficiently precise manner to allow us to locate that material.
      </li>
      <li>
        Adequate information by which we can contact you (including your name,
        postal address, telephone number, and, if available, email address).
      </li>
      <li>
        A statement that you have a good faith belief that use of the
        copyrighted material is not authorized by the copyright owner, its
        agent, or the law.
      </li>
      <li>
        A statement that the information in the written notice is accurate.
      </li>
      <li>
        A statement, under penalty of perjury, that you are authorized to act on
        behalf of the copyright owner.
      </li>
    </ul>
    <p>Our designated Copyright Agent to receive DMCA notices is:</p>
    <p>
      Marc Randazza
      <br />
      Randazza Legal Group, PLLC
      <br />
      4974 S. Rainbow Blvd., Suite 100
      <br />
      Las Vegas, NV 89118
      <br />
      702-420-2001
      <br />
      <a href="mailto:cvv@cvvhelp.net">cvv@cvvhelp.net</a>
    </p>
    <p>
      If you fail to comply with all the requirements of Section 512(c)(3) of
      the DMCA, your DMCA Notice may not be effective.
    </p>
    <p>
      Please be aware that if you knowingly materially misrepresent that
      material or activity on the Platform is infringing your copyright, you may
      be held liable for damages (including costs and attorneys&#39; fees) under
      Section 512(f) of the DMCA.
    </p>
    <h3 id="2">Counter-Notification Procedures</h3>
    <p>
      If you believe that material you posted on the Platform was removed or
      access to it was disabled by mistake or misidentification, you may file a
      counter-notification with us (a &quot;Counter-Notice&quot;) by submitting
      written notification to our Copyright Agent (identified below). In
      accordance with the DMCA, the Counter-Notice must include substantially
      the following:
    </p>
    <ul class="list-disc ml-8 leading-loose">
      <li>Your physical or electronic signature.</li>
      <li>
        An identification of the material that has been removed or to which
        access has been disabled and the location at which the material appeared
        before it was removed or access disabled.
      </li>
      <li>
        Adequate information by which we can contact you (including your name,
        postal address, telephone number and, if available, email address).
      </li>
      <li>
        A statement under penalty of perjury by you that you have a good faith
        belief that the material identified above was removed or disabled as a
        result of a mistake or misidentification of the material to be removed
        or disabled.
      </li>
      <li>
        A statement that you will consent to the jurisdiction of the Federal
        District Court for the judicial district in which your address is
        located (or if you reside outside the United States, the United States
        District Court for the District of Delaware) and that you will accept
        service from the person (or an agent of that person) who provided the
        Platform with the complaint at issue.
      </li>
    </ul>
    <p>Completed Counter-Notices should be sent to:</p>
    <p>
      Marc Randazza
      <br />
      Randazza Legal Group, PLLC
      <br />
      4974 S. Rainbow Blvd., Suite 100
      <br />
      Las Vegas, NV 89118
      <br />
      702-420-2001
      <br />
      <a href="mailto:cvv@cvvhelp.net">cvv@cvvhelp.net</a>
    </p>
    <p>
      The DMCA allows us to restore the removed content if the party filing the
      original DMCA Notice does not file a court action against you within ten
      business days of receiving the copy of your Counter-Notice.
    </p>
    <p>
      Please be aware that if you knowingly materially misrepresent that
      material or activity on the Platform was removed or disabled by mistake or
      misidentification, you may be held liable for damages (including costs and
      attorneys&#39; fees) under Section 512(f) of the DMCA.
    </p>
    <h3 id="3">Repeat Infringers</h3>
    <p>
      It is our policy in appropriate circumstances to disable or terminate the
      accounts of users who are repeat infringers.
    </p>
    <h3 id="4">Non-DMCA Content Take Down Requests</h3>
    <p>
      For non-DMCA related takedown requests, because you believe the content
      appears without permission, or violates some other law, please send those
      requests to:
    </p>
    <p>
      Marc Randazza
      <br />
      Randazza Legal Group, PLLC
      <br />
      4974 S. Rainbow Blvd., Suite 100
      <br />
      Las Vegas, NV 89118
      <br />
      702-420-2001
      <br />
      <a href="mailto:cvv@cvvhelp.net">cvv@cvvhelp.net</a>
    </p>
  </LayoutLegal>
</template>

<script setup>
  useSiteSeo({
    defaultTitle: "DMCA Notice | {{ siteName }}",
    defaultDescription:
      "We take claims of copyright infringement seriously. We will respond to notices of alleged copyright infringement that comply with applicable law.",
  })
</script>
